import React from 'react';
import PropTypes from 'prop-types';
import ChatView from '../../chatView/components/ChatView';
import { SESSION_TYPES } from '../../chatView/constants';
import { buildDrilldownUserMessage } from '../consts';
import css from './DrilldownView.css';

const DrilldownView = ({ payload, onBack, contextEnv, onContextEnvChange }) => (
    <div className={css.drilldownView}>
        <ChatView
            conversationOnly
            title="STATIC.BUTTONS.DRILLDOWN"
            onGoBack={onBack}
            initialPayload={{
                content: buildDrilldownUserMessage(payload),
            }}
            runPath="runs"
            sessionType={SESSION_TYPES.RCA}
            contextEnv={contextEnv}
            onContextEnvChange={onContextEnvChange}
        />
    </div>
);

DrilldownView.propTypes = {
    payload: PropTypes.shape({
        metric: PropTypes.shape({
            api_name: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired,
        }).isRequired,
        cohort_period: PropTypes.string,
        filters: PropTypes.arrayOf(PropTypes.shape({
            dimension: PropTypes.string.isRequired,
            operator: PropTypes.string,
            values: PropTypes.arrayOf(PropTypes.string).isRequired,
        })).isRequired,
        change: PropTypes.string.isRequired,
        start_date: PropTypes.string.isRequired,
        end_date: PropTypes.string.isRequired,
        previous_period_start: PropTypes.string.isRequired,
        previous_period_end: PropTypes.string.isRequired,
    }).isRequired,
    onBack: PropTypes.func.isRequired,
    contextEnv: PropTypes.string,
    onContextEnvChange: PropTypes.func,
};

export default DrilldownView;
